import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PersonalInformationRoundedCellComponent } from './personal-information-rounded-cell.component';

@NgModule({
  declarations: [PersonalInformationRoundedCellComponent],
  imports: [CommonModule],
  exports: [PersonalInformationRoundedCellComponent],
})
export class PersonalInformationRoundedCellModule {}
